import * as React from 'react';
import HLDrawer from 'components/HLDrawer';
import HLButton from 'components/HLButton';


export interface ShowMoreDrawerProps{
    drawerItem: string;
  closeDrawer: () => void;
  children: React.ReactNode;
}

export interface ShowMoreButtonProps {
  onShowMore: () => void;
  isDrawer: boolean; // true if drawer
  items: unknown[];
  showMoreThreshold?: number;
}

export interface ShowMoreDrawerChildProps{
    drawerItem: string;
  closeDrawer: () => void;
  onShowMore?: () => void;
  drawerMode: boolean;
}

export default function ShowMoreDrawer(props: ShowMoreDrawerProps) {
  const { drawerItem, closeDrawer, children } = props;

  return (
    <HLDrawer
      open={!!drawerItem}
      onClose={closeDrawer}
      title={drawerItem}
    >
      {children}
    </HLDrawer>
  );
}

export const SHOW_MORE_AFTER = 3;

export const SHOW_MORE_AFTER_MEDICATIONS = 6;

export function ShowMoreButton(props: ShowMoreButtonProps) {
  const { isDrawer, onShowMore, items, showMoreThreshold = SHOW_MORE_AFTER } = props;
  const showMore = items.length > showMoreThreshold;
  if (!isDrawer && onShowMore && showMore) {
    return (
      <HLButton sx={{ p: 0 }} onClick={onShowMore}>
        View all
      </HLButton>
    );
  }

  return null;
}

export function sliceForShowMore<T>(
  items: T[],
  slice = false,
  showMoreThreshold = SHOW_MORE_AFTER,
) {
  return slice
    ? items.slice(0, showMoreThreshold)
    : items;
}
